import Vue from 'vue'
import Vuex from 'vuex'

// Stores
import User from '@/store/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user: User
  }
})
